const env = location.host.split('.')[0].match(/(qc|box)\d?/g)
const spell = !!env ? (env.length > 0 ? `-${env[0]}` : '') : ''
const WXDOMAIN = `//wx${spell}.xinli001.com/`,
  LXDOMAIN = spell?`//lingxi${spell}.xinli001.com/lingxi/service/`:`//m-lingxi${spell}.xinli001.com/lingxi/service/`,
  YIAPI = `//yiapi${spell}.xinli001.com/v5/yi/`,
  APIS = {
    // 导入此刻接口 
    lifeCardCardList: `${LXDOMAIN}consult/getOrgId`, //获取生涯卡列表
    fecthNotCompleteCount: `${LXDOMAIN}consult/notCompleteCount`, //获取生涯卡列表
  }

export default APIS


// WEBPACK FOOTER //
// ./src/apis/cike.js